/**
 * 数值千分位，格式化整数
 * @param {number|string} value
 */
export const formatInteger = (value) => {
  return Number(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,')
}

/**
 * 数值千分位，格式化浮点数
 * @param {number|string} value
 * @param {number} fixed
 */
export const formatFloat = (value, fixed) => {
  return Number(value)
    .toFixed(fixed)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

/**
 * 数值千分位表示
 * @param {number|string} value
 * @param {number?} fixed
 * @returns {string}
 */
export const numberFormat = (value, fixed) => {
  if (value || value === 0) {
    // 保留小数位，格式化浮点数
    if (fixed) {
      return formatFloat(value, fixed)
    }
    // 不保留小数位，格式化整数
    return formatInteger(value)
  }
  return ''
}


/**
 * 通用的数字千分位格式化函数
 */
export const commonFormatter = (cellValue) => {
  if (cellValue || cellValue === 0) {
    const value = String(cellValue).trim()
    if (value === '') {
      return ''
    }
    // 如果已经有千分位则不处理
    if (/,/.test(value)) {
      return value
    }
    const match = value.match(/^([+-]?)(\d+)(\.\d+)?$/)
    if (!match) {
      return value
    }
    const sign = match[1]
    const integerPart = match[2]
    const decimalPart = match[3] || ''
    return `${sign}${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${decimalPart}`
  }
  return ''
}

import { summation } from '@/utils/common'
export const sumTotal = (data, field, cnyType) => {
  const value = summation(data || [], field, cnyType)
  if (value === '' || value === '-') {
    return value
  }
  return numberFormat(value, 2)
}
